import { cn } from '@/lib/cn';

import type { LauncherApp } from './catalog';

// Preset gradients for apps without a bundled graphic — picked deterministically
// from the app id so a given app always gets the same color.
const FALLBACK_GRADIENTS = [
  'linear-gradient(135deg,#3d2a4d,#241a30)',
  'linear-gradient(135deg,#1e4a44,#12302c)',
  'linear-gradient(135deg,#1c4a3a,#0f2e24)',
  'linear-gradient(135deg,#2a3a5a,#1a2438)',
  'linear-gradient(135deg,#5a3226,#33190f)',
] as const;

function gradientFor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return FALLBACK_GRADIENTS[hash % FALLBACK_GRADIENTS.length]!;
}

interface AppIconProps {
  app: LauncherApp;
  className?: string;
}

/** Renders an app's bundled graphic, or a color+initial tile when none exists. */
export default function AppIcon({ app, className }: AppIconProps) {
  const base = 'flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl';

  if (app.icon) {
    return (
      <span className={cn(base, className)}>
        <img src={app.icon} alt="" className="h-full w-full object-contain" loading="lazy" />
      </span>
    );
  }

  return (
    <span
      className={cn(base, 'font-display text-xl font-semibold text-white/90', className)}
      style={{ background: gradientFor(app.id) }}
      aria-hidden
    >
      {app.name.charAt(0).toUpperCase()}
    </span>
  );
}
